<template>
  <div>
    <vm-table
        ref="vmTable"
        height="70Vh"
        :filter.sync="filter"
        module="basic"
        url="checkReportBinds">
      <template slot="adSearch">
        <div class="vm-search">
          <vm-search label="出厂编号">
            <el-input
                v-model.trim="filter.factoryNo"
                style="width: 150px"
                clearable/>
          </vm-search>
        </div>
      </template>
      <el-table-column prop="factoryNo" label="出厂编号" align="center" width="120"/>
      <el-table-column prop="repairOrderNo" label="工单号" align="center" width="220"/>
      <el-table-column prop="customerName" label="客户名称" align="center"/>
      <el-table-column prop="createTime" label="创建时间" width="220" align="center"/>
      <el-table-column prop="creatorName" label="创建人" width="220" align="center"/>
      <el-table-column prop="status" label="状态" width="220" align="center"/>
      <el-table-column
          label="操作"
          align="center"
          fixed="right"
          width="240">
        <template slot-scope="scope">
          <el-button type="primary" @click="$refs.editPage.open(scope.row)">编辑</el-button>
          <el-button :loading="sentEmailLoading" type="primary" @click="sentEmail(scope.row.pkid)">邮件推送</el-button>
        </template>
      </el-table-column>
    </vm-table>
    <k-z-g-report-sent-email-edit ref="editPage"/>
  </div>
</template>
<script>

  import VmTable from "@/components/VmTable";
  import VmSearch from "@/components/VmSearch";
  import KZGReportSentEmailEdit from "@/views/purchase/kzgReport/KZGReportSentEmailEdit";
  export default {
    name: "KZGReportList",
    components: {KZGReportSentEmailEdit, VmTable, VmSearch},
    data() {
      return {
        filter: {
          factoryNo: "",
          status: "10",
          barcode: "",
          bordType: 0,
          procurementInspection: "",
          beginCreateTime: "",
          endCreateTime: "",
        },
        sentEmailLoading:false,
        idList: [],
        tableData: {},
      };
    },
    mounted() {
      this.$refs.vmTable.getList(1);
    },
    methods: {
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      sentEmail(id) {
        this.sentEmailLoading = true;
        this.$http
          .get("basic", `checkReportBinds/sentEmail/${id}`)
          .then(() => {
            this.sentEmailLoading = false;
          }).catch(() => {
            this.sentEmailLoading = false;
          });
      },
    },
  };

</script>

<style>

</style>